import React, { useEffect, useRef } from "react";
import Styles from './styles.module.scss';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Route, Routes, Outlet, useLocation } from "react-router-dom";
import MainPage from "../../pages/mainPage";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../store/cabinet/action";
import PublicHeader from "../publicHeader";
import PublicFooter from "../publicFooter";
import HowItWorksPage from "../../pages/howItWorksPage";
import CabinetMatrixPage from "../../pages/cabinetMatrixPage";
import CabinetSidebar from "../cabinetSidebar";
import CabinetTopBar from "../cabinetTopBar";
import CabinetTabBar from "../cabinetTabBar";
import CabinetRoadmapPage from "../../pages/cabinetRoadmapPage";
import CabinetLeaderboardPage from "../../pages/cabinetLeaderboardPage";
import CabinetReferralPage from "../../pages/cabinetReferralPage";
import CabinetContestsPage from "../../pages/cabinetContestsPage";
import LogPage from "../../pages/logPage";
import RegPage from "../../pages/regPage";
import ResPage from "../../pages/resPage";
import CabinetSettingsPage from "../../pages/cabinetSettingsPage";
import CabinetTransactionsPage from "../../pages/cabinetTransactionsPage";
import CabinetEventsPage from "../../pages/cabinetEventsPage";
import CabinetWalletPage from "../../pages/cabinetWalletPage";
import ComingSoon from "../comingSoon";

const MainLayout = () => (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_ID}>
        <div className={`${Styles.main} ${window.location.pathname.indexOf('how-it-works') === 1 ? Styles.mainGod : null}`}>
            <PublicHeader />
            <Outlet />
            <PublicFooter />
        </div>
    </GoogleOAuthProvider>
);

const CabinetLayout = () => {
    const authStatus = useSelector(store => store.main.authorizationStatus);
    const userData = useSelector(store => store.cabinet.userData);
    const userDataErr = useSelector(store => store.cabinet.userDataErr);
    const {pathname} = useLocation();
    const mainRef = useRef(null);

    // при переходе между страницами контент всегда открывается с начала
    useEffect(() => {
        if (mainRef.current) mainRef.current.scrollTo({top: 0, behavior: 'instant'});
        window.scrollTo({top: 0, behavior: 'instant'});
    }, [pathname]);
    // Доступ в кабинет только если у пользователя allowed: true
    const allowed = userData?.user?.allowed === true || userData?.allowed === true;
    const cmStatus = !allowed;

    // Пока данные пользователя грузятся — ничего не показываем, чтобы не мигала заглушка
    if (authStatus && !userData && !userDataErr) return <div className={`${Styles.cabinet}`} />;

    return (
    <div className={`${Styles.cabinet} ${Styles.cabinetRedesign}`}>
        {
            cmStatus ?
                <ComingSoon/> :
                <div className={`${Styles.shell}`}>
                    <div className={`${Styles.shellBg}`}/>
                    <div className={`${Styles.shellSidebar}`}>
                        <CabinetSidebar />
                    </div>
                    <main ref={mainRef} className={`${Styles.shellMain}`}>
                        <CabinetTopBar />
                        <Outlet />
                    </main>
                    <CabinetTabBar />
                    <ToastContainer theme="dark" position="top-right" autoClose={4000}/>
                </div>
        }

    </div>
    );
};

const App = () => {
    const dispatch = useDispatch();
    const authStatus = useSelector(store => store.main.authorizationStatus);


    useEffect(() => {
        if (authStatus) {
            dispatch(getUserData());
        }
    }, [authStatus, dispatch]);


    return  (
        <section className={Styles.container}>
            <Routes>
                <Route element={<MainLayout />}>
                    <Route exact path="/" element={<MainPage />} />
                    <Route exact path="/how-it-works" element={<HowItWorksPage />} />
                    <Route exact path="/sign-in" element={<LogPage />} />
                    <Route exact path="/sign-up" element={<RegPage />} />
                    <Route exact path='/sign-up/ref/:refCode' element={<RegPage/>}/>
                    <Route exact path="/reset-password" element={<ResPage />} />
                    {/*<Route exact path="/event" element={<EventPage />} />*/}
                    {/*<Route exact path="/main" element={<CabinetMainPage />} />*/}
                    {/*<Route exact path="/store" element={<StorePage />} />*/}
                </Route>
                <Route element={<CabinetLayout />}>
                    <Route exact path="/matrix" element={<CabinetMatrixPage/>}/>
                    <Route exact path="/wallet" element={<CabinetWalletPage/>}/>
                    <Route exact path="/roadmap" element={<CabinetRoadmapPage/>}/>
                    <Route exact path="/leaderboard" element={<CabinetLeaderboardPage/>}/>
                    <Route exact path="/referral-program" element={<CabinetReferralPage/>}/>
                    <Route exact path="/contests" element={<CabinetContestsPage/>}/>
                    <Route exact path="/settings" element={<CabinetSettingsPage/>}/>
                    <Route exact path="/transactions" element={<CabinetTransactionsPage/>}/>
                    <Route exact path="/events" element={<CabinetEventsPage/>}/>
                </Route>
            </Routes>
        </section>
    );
};

export default App;
